import round from 'lodash/round'

const DEFAULT_EXCHANGE_RATE_ROUNDING = 5

export const calculateExchangeRate = (paymentAmount: number, subjectAmount?: number): number | undefined => {
  if (!subjectAmount) {
    return undefined
  }

  return round(paymentAmount / subjectAmount, DEFAULT_EXCHANGE_RATE_ROUNDING)
}
